<template>
  <div>
    <report-conversation :type="'inbox'"></report-conversation>
  </div>
</template>

<script>
import ReportConversation from './ReportConversation'
export default {
  components: {
    ReportConversation
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/Inbox.vue